import { initContext, useInitContextValue } from './context';

export interface InitProviderProps {
  children: (spin: ReactNode) => ReactNode;
}

export function InitProvider({ children }: InitProviderProps) {
  const value = useInitContextValue();
  const { initialed } = value;

  const placeholder = useMemo(
    () => (initialed ? null : <Spin fullscreen></Spin>),
    [initialed]
  );

  return (
    <initContext.Provider value={value}>{children(placeholder)}</initContext.Provider>
  );
}
